<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内容 -->
    <div class="container" :style="{'background':`url('${dataObj.bigPicUrl}') no-repeat center top`}">
      <div class="wrap">
        <div class="navigation">
          <div class="breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">{{$t('otherPage.p1')}}</el-breadcrumb-item>
              <el-breadcrumb-item @click.native="toUrl(firstNav.url)">{{firstNav.title}}</el-breadcrumb-item>
              <el-breadcrumb-item>{{$t('otherPage.p9')}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="back" @click="toBack" :style="{'width' : $store.getters.lang=='en'?'114px':''}">
            <img src="@/assets/images/ExhibitionA1Detail01@2x.png" alt=""> {{$t('otherPage.p20')}}
          </div>
        </div>
        <div class="main">
          <div class="main-t">
            <img width="614" height="490" :src="dataObj.picUrl" alt="">
            <img width="614" height="490" :src="dataObj.picUrl2" alt="">
          </div>
          <div class="main-m">
            <div class="title">{{dataObj.name}} {{dataObj.title}}</div>
            <div class="content" v-html="dataObj.detail"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {getDetail} from '@/api'
  // import {getExhibitionA4Detail} from "@/api"
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import {mixin} from '@/mixin/index.js';

  export default {
    name: "Detail",
    mixins:[mixin],
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        // 一级Nav
        firstNav: {},
        // 详情数据
        dataObj:{},
        // 大图
        bigPicUrl:''
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        // 更新静态数据(后退)
        this.$router.go(-1);
      }
    },
    created() {
      // 设置背景颜色
      document.body.style.backgroundColor = "#f2f2f2"
      // 获取详情对应的一级导航
      if(this.$store.getters.lang =='zh'){
        this.$store.getters.menu.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.$set(this,"firstNav",val)
          }
        })
      }else{
        this.$store.getters.menuEn.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.$set(this,"firstNav",val)
          }
        })
      }
      // 获取数据
      this.toGetData()
      this.toGetBanner()
      // getExhibitionA4Detail({id:this.$route.params.id}).then((res) => {
      //   this.dataObj = res.data.data
      // })
    },
    methods: {
      // 获取数据
      toGetBanner(){
        this.$store.getters.banner.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.bigPicUrl = val.url
          }
        })
      },
      async toGetData() {
        let {data:{data}} = await getDetail({
          id : this.$route.params.id,
        })

        if(!data){
          this.$router.push('/404');
        }

        let showtemFacethum = data.faceThum ? data.faceThum.split(',') : []

        this.dataObj = {
          id : data.id,
          title :  data.smallTitle.split("|")[1],
          name : data.smallTitle.split("|")[0],
          picUrl : showtemFacethum[0]?this.$store.getters.urlApi + showtemFacethum[0] : '',
          picUrl2 : showtemFacethum[1]?this.$store.getters.urlApi + showtemFacethum[1] : '',
          bigPicUrl :this.bigPicUrl,
          detail : this.updateImageUrl(data.articleContent),
        }
      },
      // 返回
      toBack(){
        this.$router.go(-1);
      },
      // 跳转二级导航
      toUrl(path) {
        if (this.$router.currentRoute.path !== path) {
          this.$router.push(path);
        }
      }
    },
  }
</script>


<style scoped lang="less">
  /deep/ .el-breadcrumb__inner {
    color: #fff !important;
  }
  .el-breadcrumb {
    font-size: 20px;
  }

  .el-breadcrumb__item {
    cursor: pointer;
  }

  .container {
    background-size: cover;
    overflow: hidden;

    .wrap {
      width: 1380px;
      margin: 230px auto 140px;

      .navigation {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .back {
          width: 92px;
          height: 38px;
          line-height: 38px;
          background: #FFFFFF;
          text-align: center;
          font-family: PingFangSC;
          font-weight: 500;
          font-size: 18px;
          color: #999999;
          cursor: pointer;
          img {
            margin-right: 6px;
            position: relative;
            top: -2px;
          }
        }

      }

      .main{
        margin-top: 30px;
        padding: 60px 59px 54px;
        background: #fff;

        .main-t {
          display: flex;
          justify-content: space-between;
        }
        .main-m {
          padding: 40px 0 0;
          background: #fff;

          .title {
            font-family: PingFangSC;
            font-weight: 600;
            font-size: 34px;
            color: #333333;
            margin-bottom: 40px;
          }

          .content {
            font-size: 24px;
            color: #333333;
            line-height: 36px;
            text-align: justify;
            img {
              max-width: 100%;
            }
          }
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Exhibition/A4/Detail.vue